export default function DashboardStatsGrid({ stats, isLoading }) {
  return (
    <div className="stats-grid-modern">
      {/* Prospects enrichis */}
      <div className="stat-card-modern">
        <div className="stat-header">
          <span className="stat-label">Prospects enrichis</span>
          <span className={`stat-trend ${stats.prospectsTrend >= 0 ? 'positive' : 'negative'}`}>
            {stats.prospectsTrend ? `${stats.prospectsTrend >= 0 ? '+' : ''}${stats.prospectsTrend}%` : '-'}
          </span>
        </div>
        <div className="stat-value-large">{isLoading ? '-' : (stats.totalProspects || 0).toLocaleString('fr-FR')}</div>
        <div className="stat-chart">
          {[45, 60, 35, 75, 55, 85, 100].map((h, i) => (
            <div key={i} className="chart-bar" style={{ height: `${h}%` }}></div>
          ))}
        </div>
      </div>

      {/* Crédits disponibles */}
      <div className="stat-card-modern">
        <div className="stat-header">
          <span className="stat-label">Crédits disponibles</span>
          <span className="stat-trend">-</span>
        </div>
        <div className="stat-value-large">{isLoading ? '-' : (stats.currentCredits || 0).toLocaleString('fr-FR')}</div>
        <div className="stat-mini-stats">
          <div className="mini-stat">
            <span className="mini-label">Utilisés cette semaine</span>
            <span className="mini-value">{stats.recentCreditsUsed || 0}</span>
          </div>
        </div>
      </div>

      {/* Recherches cette semaine */}
      <div className="stat-card-modern">
        <div className="stat-header">
          <span className="stat-label">Recherches cette semaine</span>
          <span className="stat-badge"></span>
        </div>
        <div className="stat-value-large">{isLoading ? '-' : (stats.recentSearchesCount || 0)}</div>
        <div className="stat-mini-stats">
          <div className="mini-stat">
            <span className="mini-label">Total historique</span>
            <span className="mini-value">{stats.totalSearches || 0}</span>
          </div>
        </div>
      </div>

      {/* Crédits utilisés (total) */}
      <div className="stat-card-modern">
        <div className="stat-header">
          <span className="stat-label">Crédits utilisés (total)</span>
          <span className="stat-badge">{stats.recentCreditsUsed || 0} cette semaine</span>
        </div>
        <div className="stat-value-large">{isLoading ? '-' : (stats.totalCreditsUsed || 0).toLocaleString('fr-FR')}</div>
        <div className="stat-sparkline">
          <svg viewBox="0 0 100 30" preserveAspectRatio="none">
            <polyline fill="none" stroke="currentColor" strokeWidth="2" points="0,20 20,15 40,18 60,10 80,12 100,8" />
          </svg>
        </div>
      </div>
    </div>
  )
}
